import BottomNavBar from "../components/generalComponents/BottomNavBar";
import Header from "../components/generalComponents/Header";
import AllSuppliersGrid from "../components/infoScreens/AllSuppliersGrid";

export default function AllSuppliersView() {
  return (
    <div className="pageWrapper">
      <Header variableSupplierTitle={true} />
      <div className="contentWrapper fadeInDelayed">
        <AllSuppliersGrid />
      </div>
      <BottomNavBar />
    </div>
  );
}
